import React from "react";
import { Form, Formik, Field } from "formik";
import { ApiService } from "../../../../../services/ApiService";

export default function EditSubcategory({
  closeModal,
  alert,
  value,
  getAllSubcategories,
  requestType,
}) {
  console.log("vals", value);

  return (
    <React.Fragment>
      <div className="">
        <h4 className="modal-title w-100" style={{ color: "#000" }}>
          Edit Office Subcategory
        </h4>
        <hr />
      </div>
      <Formik
        initialValues={{
          name: value.subCategory,
          request_type: value.request_type.id,
          id: value.id,
        }}
        onSubmit={(values) => {
          ApiService.post(`request-categories/${value.id}`, values).then(
            (res) => {
              if (res.data.type === false) {
                alert.error(res.data.msg);
              } else if (res.data.type === true) {
                alert.success(res.data.msg);
              }
              getAllSubcategories();
              closeModal();
            }
          );
        }}
      >
        {({ handleSubmit, values, isSubmitting, handleChange }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Request Type <span className="text-danger"> * </span>
                  </label>
                  <Field
                    name="request_type"
                    as="select"
                    className="form-control select2 required"
                  >
                    <option>--Select Request Type--</option>
                    {requestType.map((request, i) => (
                      <option value={request.id} key={i}>
                        {request.name}
                      </option>
                    ))}
                  </Field>
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Subcategory
                    <span className="text-danger"> * </span>
                  </label>
                  <Field
                    type="text"
                    className="form-control"
                    name="name"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/systemconfiguration/subCategory/modal/edit_subcategory.js